import { observer } from 'mobx-react';
import { FC, ReactElement } from 'react';
import ProductModifier from '../../components/ProductModifier/ProductModifier';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import { IResponseComboItem } from '~/types/combo';
import { IResponseProductModifier } from '~/types/products';
import { productUtils } from '~/utils/productUtils';
import Text from '~/view/components/Text/Text';

interface IProps {
  item: IResponseComboItem;
  onChangeModifier: (modifier: IResponseProductModifier) => void;
}

export const MealItemModifiers: FC<IProps> = observer(({ item, onChangeModifier }: IProps): ReactElement | null => {
  const checkModifierErrors = (modifier: IResponseProductModifier): boolean => {
    return productUtils.isMealModifierWithError(item, modifier.id, orderProductModalStore.modifiersWithError);
  };

  const hasEmptyModifiers = item.modifiers?.every((modifier) => modifier.options.length === 0);

  if (hasEmptyModifiers) return null;

  return (
    <div className="d-flex flex-column mb-4 gap-20">
      <Text type="section-header" text="modifiers" />

      {item.modifiers?.map((modifier) => (
        <ProductModifier
          key={modifier.id}
          modifier={modifier}
          isModifierWithError={checkModifierErrors(modifier)}
          onChangeModifier={onChangeModifier}
        />
      ))}
    </div>
  );
});
